import React, {Component} from "react";
import $ from 'jquery';
import './UserProfileNavBar.css'
import userProf from '../../../assets/img/user.profile.png'
import {Link} from "react-router-dom";
import {FormattedMessage} from "react-intl";
import Modal from "react-bootstrap/lib/Modal";
import axios from "axios";
import {BASE_URL, RESOURCE_BASE_URL} from "../../../configuration";

class UserProfileNavBar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activateShowMobile : false,
            userInfo : null
        };

        this.collapseProfileNavBar = this.collapseProfileNavBar.bind(this);
        this.deactivateAccountHandle = this.deactivateAccountHandle.bind(this);
        this.conformDeleteAccountMobile = this.conformDeleteAccountMobile.bind(this);
        this.getUserDetailsMobile = this.getUserDetailsMobile.bind(this);
    }

    componentDidMount() {
        this.getUserDetailsMobile(this.props.userId);

        var collapsed = true;
        $("#btnJ").click(function () {
            collapsed = !collapsed;
            if (collapsed) {
                $("#spanJ").slideUp('slow');
            } else {
                $("#spanJ").slideDown('slow');

            }
        });
    }

    deactivateAccountHandle = (status) => {


        this.setState({
            activateShowMobile: status
        })

    };
    getUserDetailsMobile = (userId) => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/users/' + userId, axiosConfig)
            .then((res) => {
                this.setState({
                    userInfo: res.data
                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };


    conformDeleteAccountMobile = (deactivation) => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access-Control-Allow-Origin': '*'
            }
        };

        axios.get(RESOURCE_BASE_URL + 'api/admin/users/activation/' + this.props.userId + '/' + deactivation, axiosConfig)
            .then((res) => {

                if (res.data === "active") {
                    this.setState({
                        status: res.data,
                        activateShowMobile: false
                    })
                } else {
                    this.setState({
                        status: res.data,
                        deactivateShow: false,
                    })
                }

            })
            .catch((err) => {
                console.log("AXIOS ERROR: ", err);
            });
    };

    collapseProfileNavBar = () => {
        document.getElementById("spanJ").style.display = "none";
    };

    render() {
        return (
            <div className="row row-resp">
                <div className="col-md-12 collapse-position">
                    <div className="profile-collapse" id="btnJ">
                        <div className="row row-resp">
                            <div className="custom-col-10 text-center-responsive order-history-resp">
                                {this.props.itemName}
                            </div>
                            <div className="custom-col-2 profile-toggler-div">
                                <button type="button" className="navbar-toggle navbar-toggle-profile">
                                    <span className="icon-bar icon-bar-white"></span>
                                    <span className="icon-bar icon-bar-white"></span>
                                    <span className="icon-bar icon-bar-white"></span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div id="spanJ" className="profile-collapse-content ">

                        <div className="collapse-row">
                            <Link to="/profile" onClick={this.collapseProfileNavBar}>
                                ユーザープロファイル
                            </Link>

                        </div>


                        <div className="collapse-row">
                            <Link to="/userProfileSetting" onClick={this.collapseProfileNavBar}>
                                <FormattedMessage id="app.user-profile.user-profile-edit.button"
                                                  defaultMessage="Update User Info"
                                                  description=""/>

                            </Link>
                        </div>
                        <div className="collapse-row">
                            <Link to="/changePassword">
                                <FormattedMessage id="app.user-profile.user-profile-info.change-password"
                                                  defaultMessage="Change Password"
                                                  description=""
                                />
                            </Link>
                        </div>
                        {this.state.userInfo !== null ?

                            this.state.userInfo.userRole === "USER" ?
                            <div className="collapse-row">
                                <a onClick={()=>this.deactivateAccountHandle(true)}>
                                    アカウント削除
                                </a>
                            </div> : ''

                            : ''
                        }

                        <div className="collapse-row">
                            <Link to="/quotation/pcb" onClick={this.collapseProfileNavBar}>
                                <FormattedMessage id="app.user-profile.user-profile.side-bar.board-manufacturing-estimate"
                                                  defaultMessage="View Quotation"
                                                  description=""/>

                            </Link>
                        </div>

                        <div className="collapse-row">
                            <Link to="/order/all" onClick={this.collapseProfileNavBar}>
                                <FormattedMessage id="app.user-profile.user-profile-info.order-history"
                                                  defaultMessage="View Order History"
                                                  description=""
                                />
                            </Link>
                        </div>
                        <div className="collapse-row">
                            <Link to="/inquiry_list" onClick={this.collapseProfileNavBar}>
                                <FormattedMessage id="app.user-profile.user-profile-info.inquiries"
                                                  defaultMessage="View Inquiries"
                                                  description=""
                                />
                            </Link>
                        </div>
                        <div className="collapse-row">
                            <Link to="/complaint_list" onClick={this.collapseProfileNavBar}>
                                品質報告履歴
                            </Link>
                        </div>
                        {/*<div className="collapse-row">*/}
                            {/*<a className="collapse-row-link" href="">ログアウト</a>*/}
                        {/*</div>*/}
                    </div>

                </div>

                <Modal dialogClassName="user-aaaaaa-modal" show={this.state.activateShowMobile}
                       onHide={()=>this.deactivateAccountHandle(false)}
                >
                    <Modal.Header closeButton
                                  onHide={()=>this.deactivateAccountHandle(false)}>
                        <div className="title-1 color-text">
                            {/*<FormattedMessage id="app.admin-all-row.deactivate-user"*/}
                            {/*defaultMessage="Deactivate User"*/}
                            {/*description=""/>*/}
                            アカウント削除
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="color-text">
                            <div className="row">
                                <div className="col-md-12 data-label">

                                    {/*<FormattedMessage id="app.admin-all-row.deactivate-confirm"*/}
                                    {/*defaultMessage="Are you sure you want to deactivate the user ?"*/}
                                    {/*description=""/>*/}
                                    KITCUTのアカウントを削除すると、アカウントのすべての情報が削除され、<br/>
                                    元に戻すことはできません。
                                    <br/>
                                    <br/>

                                    <b><span className='text-color-user-profile'>アカウントを削除しますか？</span></b>
                                </div>


                            </div>
                            <div className="form-row-spacer"></div>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="col-md-12">

                            <button className="btn btn-primary col-md-2 pull-right"
                                    onClick={() => this.deactivateAccountHandle(false)}
                            >
                                <FormattedMessage id="app.admin-all-row.deactivate-no"
                                                  defaultMessage="No"
                                                  description=""/>
                            </button>
                            <button className="btn btn-success col-md-2 pull-right delete-btn-yes"
                                    onClick={() => this.conformDeleteAccountMobile(false)}
                            >
                                <FormattedMessage id="app.admin-all-row.deactivate-yes"
                                                  defaultMessage="Yes"
                                                  description=""/>
                            </button>
                        </div>
                    </Modal.Footer>
                </Modal>

            </div>
        )

    }

}

export default UserProfileNavBar;




// WEBPACK FOOTER //
// ./src/components/Site/UserProfile/UserProfileNavBar.js